module.exports = __webpack_public_path__ + "static/media/profile_pic_400x400.7005e218.png";